import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SELECTOR = ".feature-card, .brand-card, .brand-row, .cert-card, .stats__item, .leader, .blog-card, .value__tab, .founder-note, .contact__form";

const RevealManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const raf = requestAnimationFrame(() => {
      const els = Array.from(document.querySelectorAll(SELECTOR));
      if (prefersReduced) return;
      els.forEach((el) => el.classList.add("reveal"));

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              e.target.classList.add("reveal-in");
              io.unobserve(e.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: "0px 0px -40px 0px" }
      );
      els.forEach((el) => io.observe(el));

      // safety: reveal anything still hidden after 1.2s
      window.__revealFallback = setTimeout(() => {
        els.forEach((el) => el.classList.add("reveal-in"));
      }, 1200);

      RevealManager._cleanup = () => {
        io.disconnect();
        clearTimeout(window.__revealFallback);
      };
    });

    return () => {
      cancelAnimationFrame(raf);
      if (RevealManager._cleanup) RevealManager._cleanup();
    };
  }, [pathname]);

  return null;
};

export default RevealManager;
